import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { TrialBalanceScreen } from "../screens/TrialBalanceScreen";
import { trialBalanceSearch } from "../screens/reportSearch";

export const Route = createFileRoute("/prototype/c/$companyId/reports/trial-balance")({
  validateSearch: (search) => trialBalanceSearch.parse(search),
  component: TrialBalance,
});

function TrialBalance() {
  const { companyId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <TrialBalanceScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      search={search}
    />
  );
}
